<template>
  <section
    class="bg-situational-lightgrey -mx-4 space-x-1"
    :class="{
      'shimmer-background': nearestSearchesData.isLoading.value,
    }"
  >
    <OneWayNearestSearchesShimmers
      v-if="nearestSearchesData.isLoading.value || isLoading"
    />
    <OneWayNearestSearchesList
      v-else-if="nearestSearchesData.nearestSearches.value"
      :searches-list="nearestSearchesData.nearestSearches.value"
      @onDateSelect="handleDateSelect"
    />
  </section>
</template>

<script setup lang="ts">
  import type { Ref } from 'vue';

  import OneWayNearestSearchesShimmers from './OneWayNearestSearchesShimmers.vue';
  import OneWayNearestSearchesList from './OneWayNearestSearchesList.vue';
  import type { MappedNearestSearch } from '../types';

  const props = defineProps<{
    selectedDepDate: string;
    isLoading: boolean;
    nearestSearchesData: {
      nearestSearches: Ref<MappedNearestSearch[]>;
      isLoading: Ref<boolean>;
      init: (searchQuery: string) => void;
    };
  }>();

  const emit = defineEmits<{ onDateSelect: [departureDate: string] }>();

  const handleDateSelect = (date: string) => {
    if (date !== props.selectedDepDate) {
      emit('onDateSelect', date);
    }
  };
</script>
